import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { ImageListSummaryCardDetails } from '@bingads-webui-campaign-react/pmax-image-experience';

export const Videos = ({
  data,
  label,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label }}>
      <ImageListSummaryCardDetails i18n={i18n} videos={data} isLogos={false} isVideos />
    </PropertyRow>
  );
};

Videos.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string,
};

Videos.defaultProps = {
  data: [],
  label: _TL_('Videos'),
};
